<template>
    <div class="form-container bg-white">
        <div class="form-container-header">
            <div class="form-title">
                <div
                    class="form-title-title"
                    v-html="'Please enter your email address for instructions on how to reset your password.'"></div>
            </div>
        </div>
        <form
            class="form-container-body"
            @submit.prevent='send'>
            <div class="form-container-body">
                <div class="form-row">
                    <div class="col-12 col-sm-12">
                        <div class="form-group">
                            <input
                                type="email"
                                name="user_email"
                                v-model='email'
                                v-validate='"required|email"'
                                :class="{'is-danger': errors.has('user_email') }"
                                class="form-control"
                                :placeholder="'Petras@petrita.l'"
                            >
                        </div>
                    </div>
                    <transition name="fade" v-if="$store.state.loading">
                        <b-col md="12" class="d-flex justify-content-center mb-2">
                            <b-spinner class="align-middle text-info"></b-spinner>
                        </b-col>
                    </transition>
                </div>
            </div>
            <div class="form-container-footer pb-3">
                <button type="submit" class="btn btn-accent">Send</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: 'ForgotPassword',
        data() {
            return {
                email: ''
            }
        },
        methods: {
            send() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$api('PATCH', this.$endpoints.forgotPassword.sendEmail, null, {email: this.email}).then(() => {
                            this.$store.dispatch('globalAlertAction', {
                                type: 'success',
                                title: 'Sent to your email instructions on how to reset your password.',
                                timeout: 5000
                            })
                            this.$router.push({name: 'login'})
                        })
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Authentication/ForgotPassword/ForgotPassword.vue